import React, { memo, ReactNodeArray, useContext, useMemo } from 'react'
import { Footer, ScreenContext } from 'react-components'

import {
    Container,
    LinksContainer,
    LinksContent,
    ImageContent,
    FooterContainer,
    ImageContainer,
} from './footer-section-styles'
import { ButtonTransport, FooterSectionTransport } from '@common/transports/deprecated-home-page-transport'
import FooterLink from './footer-link'

interface Props {
    footerSection: FooterSectionTransport
}

const _getLinkRows = (items: ButtonTransport[]): ReactNodeArray => {
    const linksRows = []
    for (let i = 0; i < items.length; i += 3) {
        const linkRow = items.slice(i, i + 3)
        linksRows[i / 3] = linkRow.map(link => <FooterLink key={link.url} link={link} />)
    }
    return linksRows
}

const FooterSection: React.FC<Props> = ({ footerSection: { id, items, logo, logoSmall } }) => {
    const linksRows = useMemo(() => _getLinkRows(items), [items])
    const { isDesktop } = useContext(ScreenContext)
    return (
        <Footer id={id}>
            <FooterContainer>
                <Container>
                    <ImageContainer>
                        <ImageContent
                            src={isDesktop ? logo.url : logoSmall.url}
                            alt={isDesktop ? logo.alt : logoSmall.alt}
                        />
                    </ImageContainer>
                    <LinksContainer>
                        {linksRows.map((linkRow, index) => (
                            <LinksContent key={index}>{linkRow}</LinksContent>
                        ))}
                    </LinksContainer>
                </Container>
            </FooterContainer>
        </Footer>
    )
}

export default memo(FooterSection)
